import { Component, NgZone, OnDestroy, OnInit } from '@angular/core';
import { Platform } from '@ionic/angular';
import { NetworkService } from './Network.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-Network',
  templateUrl: './Network.component.html'
})
export class NetworkComponent implements OnInit,OnDestroy  {

  network$ = this.network.getNetworkStatus();
  isError = false; Error_msg = "";
  isOnline = navigator.onLine ? "0" : "1";
  toastopen = navigator.onLine ? false : true;
  msg = "";
  
  Notification_Subscription: Subscription;
  constructor(private network: NetworkService,public plt: Platform,private zone: NgZone) {
   
  }

  ngOnInit() {
    this.plt.ready().then(async (readySource) => {
      this.Notification_Subscription = this.network$.subscribe(value => {
         this.zone.run(() => {
        if (value + "" == '1') {
          this.msg = "Sorry for the inconvenience! No network. Please reload again";
        } else {       this.msg = "";        }
      });
      })
    });

    }

  ngOnDestroy() {
    this.Notification_Subscription.unsubscribe();
    this.network.endNetworkListener();
  }
}
